const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFleetSettings(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 22 22",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    xmlnsSerif: "http://www.serif.com/",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.0459965,0,0,0.0459965,0.5,0.500023)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M97.564,79.443L13.428,79.443C6.011,79.443 0,73.428 0,66.015C0,58.602 6.011,52.587 13.428,52.587L97.564,52.587C104.981,52.587 110.992,58.602 110.992,66.015C110.992,73.428 104.981,79.443 97.564,79.443Z",
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.643,127.518C111.727,127.518 84.136,99.927 84.136,66.014C84.136,32.094 111.727,4.503 145.643,4.503C179.559,4.503 207.15,32.094 207.15,66.014C207.15,99.928 179.559,127.518 145.643,127.518ZM145.643,31.36C126.536,31.36 110.992,46.907 110.992,66.014C110.992,85.121 126.536,100.661 145.643,100.661C164.75,100.661 180.294,85.121 180.294,66.014C180.294,46.907 164.75,31.36 145.643,31.36Z",
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M443.128,79.443L202.433,79.443C195.016,79.443 189.005,73.428 189.005,66.015C189.005,58.602 195.016,52.587 202.433,52.587L443.127,52.587C450.544,52.587 456.555,58.602 456.555,66.015C456.555,73.428 450.545,79.443 443.128,79.443Z",
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M325.936,289.782C292.019,289.782 264.429,262.191 264.429,228.278C264.429,194.365 292.02,166.774 325.936,166.774C359.852,166.774 387.443,194.365 387.443,228.278C387.443,262.191 359.853,289.782 325.936,289.782ZM325.936,193.631C306.829,193.631 291.285,209.171 291.285,228.278C291.285,247.385 306.829,262.925 325.936,262.925C345.043,262.925 360.587,247.385 360.587,228.278C360.587,209.171 345.043,193.631 325.936,193.631Z",
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M269.149,241.706L13.428,241.706C6.011,241.706 0,235.691 0,228.278C0,220.865 6.011,214.85 13.428,214.85L269.149,214.85C276.566,214.85 282.577,220.865 282.577,228.278C282.577,235.691 276.566,241.706 269.149,241.706Z",
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M443.128,241.706L374.015,241.706C366.598,241.706 360.587,235.691 360.587,228.278C360.587,220.865 366.598,214.85 374.015,214.85L443.128,214.85C450.545,214.85 456.556,220.865 456.556,228.278C456.556,235.691 450.545,241.706 443.128,241.706Z",
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.62,452.052C96.704,452.052 69.113,424.461 69.113,390.541C69.113,356.628 96.704,329.037 130.62,329.037C164.536,329.037 192.127,356.628 192.127,390.541C192.127,424.461 164.536,452.052 130.62,452.052ZM130.62,355.894C111.513,355.894 95.969,371.434 95.969,390.541C95.969,409.648 111.513,425.195 130.62,425.195C149.727,425.195 165.271,409.648 165.271,390.541C165.271,371.434 149.727,355.894 130.62,355.894Z",
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M443.128,403.97L182.407,403.97C174.99,403.97 168.979,397.955 168.979,390.542C168.979,383.129 174.99,377.114 182.407,377.114L443.128,377.114C450.545,377.114 456.556,383.129 456.556,390.542C456.556,397.955 450.545,403.97 443.128,403.97Z",
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.541,403.97L13.428,403.97C6.011,403.97 0,397.955 0,390.541C0,383.128 6.011,377.113 13.428,377.113L82.541,377.113C89.958,377.113 95.969,383.128 95.969,390.541C95.969,397.955 89.958,403.97 82.541,403.97Z",
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFleetSettings);
export default __webpack_public_path__ + "static/media/fleet-settings.56f6edd6ebf570294ee397a3998f8552.svg";
export { ForwardRef as ReactComponent };